import axios from 'axios';

const fetchAndHandleColorway = (productId) => (dispatch) => {
  const url = `/api/recommendations/product-variants/${productId}/`;
  return axios
    .get(url)
    .then((response) => {
      const products = response.data.data.results;
      dispatch({ type: 'FETCH_COLORWAY_SUCCESS', payload: products });
    })
    .catch((err) => {
      dispatch({ type: 'FETCH_COLORWAY_ERROR', err });
    });
};

export default fetchAndHandleColorway;
